import { render, staticRenderFns } from "./AbUiButton.vue?vue&type=template&id=0861ee00&scoped=true&"
import script from "./AbUiButton.vue?vue&type=script&lang=js&"
export * from "./AbUiButton.vue?vue&type=script&lang=js&"
import style0 from "./AbUiButton.vue?vue&type=style&index=0&id=0861ee00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0861ee00",
  null
  
)

export default component.exports